import { Col, Collapse, Row, Typography } from "antd";
import React from "react";

export interface FormSectionProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  compact?: boolean;
  collapsible?: boolean;
  collapsed?: boolean;
  offset?: number;
}
const FormSection = ({
  title,
  subtitle,
  style,
  children,
  compact = false,
  collapsible = false,
  collapsed = true,
  offset = 6
}: FormSectionProps) => {
  let component = (
    <Row gutter={16} style={Object.assign({ marginBottom: 0 }, style)}>
      <Col lg={offset} sm={24} xs={24}>
        {collapsible ? null : (
          <Typography.Title level={compact ? 4 : 3}>{title}</Typography.Title>
        )}
        {subtitle ? (
          <Typography.Text type="secondary">{subtitle}</Typography.Text>
        ) : null}
      </Col>
      <Col lg={24 - offset} sm={24} xs={24}>
        {children}
      </Col>
    </Row>
  );

  if (!collapsible) {
    return component;
  }

  const [panelCollapsed, setPanelCollapsed] = React.useState(collapsed);

  React.useEffect(() => {
    setPanelCollapsed(collapsed);
  }, [collapsed]);

  return (
    <Collapse
      activeKey={panelCollapsed ? [] : ["0"]}
      style={{ marginBottom: 24 }}
      onChange={(key) => setPanelCollapsed(!panelCollapsed)}
    >
      <Collapse.Panel
        key="0"
        header={
          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 500
            }}
          >
            {title}
          </span>
        }
      >
        {component}
      </Collapse.Panel>
    </Collapse>
  );
};

export default FormSection;
